module.exports = "/images/ytSocialReverse.png?da2117de3a2a7f597416279fbec6a67e";